import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

export class BuildingDetails extends Component {
  static propTypes = {
    prop: PropTypes
  }

  render() {
    let account = this.props.account
    let building = account.buildings[0]

    let buildingUrl =
      building && building.detailsUrl
        ? building.detailsUrl.startsWith('http')
          ? building.detailsUrl
          : 'http://' + building.detailsUrl
        : 'http://betterspaces.com'

    return (
      <div>
        <iframe style={{ width: '100%', height: '100vh' }} src={buildingUrl} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return { account: state.authReducer.account }
}

export default connect(mapStateToProps)(BuildingDetails)



// WEBPACK FOOTER //
// ./src/components/BuildingDetails.js